export default __webpack_public_path__ + "static/media/330_portfolio03-nl-mobile.c0a66bf7.png";